import { FirmaElectronicaService } from './../../services/firma-electronica/firma-electronica.service';
import { LoginService } from './../../services/login/login.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpresasService } from '../../services/empresas/empresas.service';
import Swal from "sweetalert2";
import { environment } from 'environments/environment';

declare var $: any;
@Component({
  selector: 'app-contratos-marco',
  templateUrl: './contratos-marco.component.html',
  styleUrls: ['./contratos-marco.component.scss']
})
export class ContratosMarcoComponent implements OnInit {
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  razSocial : string;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  adjuntarPDF: boolean;
  loading: boolean = false;
  idEmpresa: string;
  tipoServicio: any;
  user: any;
  file64: any;
  ruta: any;
  rucEmpresa:any;
  pageSizeOptions = [10,20,30,50,100,200];
  contratosMarco:any = [];
  dataEnviarKeynua:any = {};
  formUpdateContratoMarco : FormGroup;
  dataSource = new MatTableDataSource( this.contratosMarco) ;
  displayedColumns: string[] = 
            ['checked','IDCMarco','Fecha_Inicio','Fecha_Final','Tipo_Servicio','Pagare','Estado','Adjunto_PDF','Adjunto_PDF_Firmado'];
  formularioContratoMarco : FormGroup;  
  abrirContratoMarco : boolean = false;
  configurarContrato :boolean;
  abrirContratoMarcoAdqui : boolean = false;
  detalleConfiguracion : boolean = false;
  constructor(private activateRoute :ActivatedRoute,
              private empresasService:EmpresasService ,
              private loginService:LoginService,
              private router :Router,
              private firmaElectronicaService:FirmaElectronicaService
              ) {
    this.tipoServicio = this.empresasService.tipoServicio            
    if (this.tipoServicio == undefined) {
      let rutas = this.router.url.split("/",3);
      this.ruta = rutas[2];
      if (this.ruta == 'proveedor') {
        this.loginService.clickGuard = true;
        this.router.navigate(['/empresas/proveedor/listado']);
      } else if (this.ruta == 'inversor') {
        this.loginService.clickGuard = true;
        this.router.navigate(['/empresas/inversor/listado']);
      } else {
        this.loginService.clickGuard = true;
        this.router.navigate(['/empresas/adquirente/listado']);
      }
    }
       
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
   }

  ngOnInit() {
    this.rucEmpresa=sessionStorage.getItem('rucEmpresa');
    this.activateRoute.params.subscribe( params => {
      this.idEmpresa =params['id'];
      this.obtenerContratosMarco(this.idEmpresa,this.tipoServicio);
    })
    let rutas = this.router.url.split("/",3);
      this.ruta = rutas[2];
      const elem=document.getElementById('button-oculto');
      elem.style.display='none';
  }

  crearContratoMarco(){
    this.empresasService.tipoServicio = this.tipoServicio
    if (this.tipoServicio == this.Id_Factoring) {
    this.abrirContratoMarco = true;
    }else{
      this.abrirContratoMarcoAdqui = true;
    }
  }
  enviarContratoKeynua(IDCMarco :any){
    Swal.fire({
      title: 'Enviar contrato marco a Keynua',
      text: '¿Desea enviar contrato digital a keynua.?',
      type: "info",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.dataEnviarKeynua.IDCMarco = IDCMarco;
        this.enviarContratoMarcoElectronico(this.dataEnviarKeynua);
      }else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    });
  }

  enviarContratoMarcoElectronico(dataEnviarKeynua){

   Swal.fire(
    'Espere',
    'Enviando contrato marco a keynua.',
    'info'
  )
  Swal.showLoading();
   this.firmaElectronicaService.enviarContratoMarcoElectronico(dataEnviarKeynua).subscribe(
       res => {  
        Swal.close();     
         this.obtenerContratosMarco(this.idEmpresa,'');
         this.showNotification('success','top','right','Documento enviado satisfactoriamente para su firma digital.');
       },err => {
        if (err.error.message) {
         this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + err.error.message);
        }else{
         let error = "";
         error = err.error.error;
         this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + error);
        }
      
      }
   );
 }
  

  CerrarPopUpNuevoContratoM(click:boolean){ 
    this.obtenerContratosMarco(this.idEmpresa,'');
    if (this.tipoServicio == this.Id_Factoring) {
    this.abrirContratoMarco = false;
    }else{
      this.abrirContratoMarcoAdqui = false;
    }
  }
  Regresar(id:any=this.rucEmpresa){
    if (this.ruta == 'proveedor') {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/proveedor/listado/',id]);
    } else if (this.ruta == 'inversor') {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/inversor/listado']);
    }else {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/adquirente/listado/',id]);
    }
  }
  obtenerContratosMarco(idEmpresa,tipoServicio){
    this.formularioContratoMarco = new FormGroup({});
    this.loading=true;
    this.empresasService.obtenerContratosMarco(idEmpresa,'')
    .subscribe(res => {
     this.loading = false;
      this.contratosMarco = res;
      if (this.tipoServicio == this.Id_Confirming) {
        this.contratosMarco = this.contratosMarco.filter(
          state => state.Tipo_Servicio_Dsc == 'CONFIRMING');
      }else{
        this.contratosMarco = this.contratosMarco.filter(
          state => state.Tipo_Servicio_Dsc != 'CONFIRMING');
      }
      this.razSocial = sessionStorage.getItem('razSocial');
      this.dataSource = new MatTableDataSource( this.contratosMarco);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      
    });

  }
  
  altaContratoMarco(element:any){

    this.adjuntarPDF = true;
    this.empresasService.dataContratoM = element;  
  }
  bajaContratoMarco(idContratoMarco){
    
    Swal.fire({
      title: "Baja de contrato marco",
      text: "¿desea dar de baja el contrato Marco Nro. "+idContratoMarco+"?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja.',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if(result.value){
        this.loading = true;
        this.formUpdateContratoMarco = new FormGroup({
          "Estado":new FormControl('B',  Validators.required),
          "Baja_Usuario":new FormControl(this.user.Usuario,  Validators.required),
          "IDCMarco":new FormControl(idContratoMarco)
        });
        this.empresasService.bajaContratoMarco(this.formUpdateContratoMarco.getRawValue())
          .subscribe(res => {
            this.obtenerContratosMarco(this.idEmpresa,'');
        })        
      }
    });    

  }

  ConfigurarContrato(element){
    this.configurarContrato = true;
    this.empresasService.dataContratoMarco = element;
   }
   verDetalle(element){
    this.detalleConfiguracion = true;
    this.empresasService.dataContratoMarco = element;
   }
  
   cerrarPopUp(){
     this.configurarContrato = false;
   }
   cerrarPopUpDetalle(){
    this.detalleConfiguracion = false;
   }
   cerrarPopUpFirmado(){
    this.adjuntarPDF = false;
   }

   showNotification(type,from,align,message){
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
